import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@legendapp/state/react';
import { ui$, closeModal, updateArticleTitle } from '../store';
import { Dialog, Input, Button } from '../design-system';

const EditTitleModal = () => {
  const { t } = useTranslation('modals');
  const modalData = useSelector(() => ui$.modalData.get());
  // 弹窗每次打开都是新挂载：直接以传入的当前标题初始化，不需要 effect 回写。
  const [title, setTitle] = useState(modalData?.currentTitle ?? '');
  const inputRef = useRef(null);

  const handleSave = () => {
    const trimmed = title.trim();
    if (!trimmed) return; // Don't allow empty
    updateArticleTitle(modalData.articleId, trimmed);
    closeModal();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    }
  };

  const isValid = title.trim().length > 0;

  return (
    <Dialog
      isOpen={true}
      onClose={closeModal}
      title={t('editTitle.title')}
      size="sm"
      initialFocusRef={inputRef}
      footer={
        <>
          <Button variant="neutral" onClick={closeModal}>
            {t('button.cancel', 'Cancel')}
          </Button>
          <Button variant="primary" onClick={handleSave} disabled={!isValid}>
            {t('button.save')}
          </Button>
        </>
      }
    >
      <Input
        ref={inputRef}
        type="text"
        value={title}
        onChange={e => setTitle(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t('editTitle.placeholder')}
      />
    </Dialog>
  );
};

export default EditTitleModal;
